import React, { useState } from 'react'
import AdminAppBar from '../../adminComponents/AdminAppBar'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios';
import marketingHubService from '../../Services/MarketingHubService';
import { showErrorToast, showSuccessToast, showWarningToast } from '../../Constant/Notification';
import { ToastContainer } from 'react-toastify';
import Loader from '../../Constant/Loader';
import BackArrows from '../../Form/BackArrow/BackArrows';

const CreateDocumentTemplate = () => {
    const navigate = useNavigate();
    const [title, setTitle]= useState();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [documentUrl, setDocumentUrl] = useState("");
  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  const userId = userObj?.user?.uid;
  const { groupId } = location.state || {}; 
    const handleBack =()=>{
navigate(-1)
    }


    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.type !== "application/pdf") {
                showWarningToast("Only PDF files are allowed. Please upload a valid PDF file.");
                return;
              }
          setSelectedFile(file);
          setLoading(true);
          try {

            const formData = new FormData();
            formData.append("file", file);

            const response = await marketingHubService.createDocumentTemplatePdf(formData)
            setDocumentUrl(response.data.documentUrl);
          } catch (error) {
            console.error("Error uploading file:", error);
            showErrorToast("Failed to upload file. Please try again.");
          }
          finally {
            setLoading(false); // Reset loading state after file upload is complete
        }
        }
      };




      const handleCreateDocument = async () => {
        if (!title || !documentUrl) {
          showErrorToast("Please provide both title and upload a document.");
          return;
        }

        const templateData = {
            title,
            documentUrl,
            group: groupId,
            createdBy: userId,
            modifiedBy:  userId
        }


        setLoading(true);
        try {
          await marketingHubService.createDocumentTemplate(templateData)

          navigate(-1, { state: { message: "Document created successfully!", groupId:groupId } });

        } catch (error) {
          console.error("Error creating document:", error);
          showErrorToast("Failed to create document. Please try again.");
        } finally {
          setLoading(false);
        }
      };
  return (
    <div className=''>
      {loading ? <Loader/> : ""}
        <AdminAppBar/>
        <ToastContainer/>
      <div className="pt-28 px-20 xl:px-6 relative flex justify-between gap-5">
        <div className="flex gap-6">
<BackArrows onClick={handleBack} />
          <div>
            <h1 className="text-4xl font-semibold whitespace-nowrap">
            New Document
            </h1>
          </div>
        </div>
        <div>
          {/* <button
            onClick={handleCreateDocument}
            className="border-2 whitespace-nowrap bg-customGreen  p-1 rounded-lg px-5 w-fit text-lg text-white h-10 text-center"
          >
            Create
          </button> */}

<button
                        onClick={handleCreateDocument}
                        className="border-2 whitespace-nowrap bg-customGreen p-1 rounded-lg px-5 w-fit text-lg text-white h-10 text-center"
                        disabled={loading || !documentUrl} // Disable button if loading or no document URL
                    >
                      Add Document
                    </button>
        </div>
      </div>

      <div className="w-10/12 mx-20 mt-14 ">
        <div className="w-full px-10 py-5 bg-white shadow-md rounded-md">

          <form className="flex flex-col gap-5">
          <div className="flex  gap-5 items-center py-6">
            <div className="">
              <h2 className="text-3xl font-medium text-gray-900">
              Content Group : 
              </h2>
            </div>
            <div>
              <h2 className="text-2xl ml-12 font-bold text-gray-900">
              Festiva Wish
              </h2>
            </div>
          </div>
            <div className="flex mb-10 items-center">
              <label
                className="w-2/6 text-3xl font-medium"
                htmlFor="title"
              >
                Document Title
              </label>
              <input
                className="shadow appearance-none bg-gray-100 border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="title"
                type="text"
                required
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>



            <div className="  flex justify-between w-full ">
              <label
                className="w-2/6  text-3xl"
                htmlFor="file-upload"
              >
                Attach File
              </label>
              <label className="w-full  ">
                <div className="relative border rounded w-full bg-appGrayBackground py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline cursor-pointer">
                  <span className="absolute inset-y-0 right-3 flex items-center pl-3">
                    <svg
                      className=" md:w-6"
                      width="30"
                      height="30"
                      viewBox="0 0 135 135"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 0H134.449V134.449H0V0Z"
                        fill="white"
                        fill-opacity="0.01"
                      />
                      <path
                        d="M67.2231 123.245H22.4067V11.2036H112.04V67.2242"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M99.4365 123.245V86.8313"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M86.8325 96.6349L91.0341 92.4334L99.4371 84.0303L107.84 92.4334L112.042 96.6349"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M44.8152 44.8159H89.6316"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                      />
                      <path
                        d="M44.8152 67.2241H67.2234"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                      />
                    </svg>
                  </span>
                  <span className="pl-0 pr-3 py-1">
                    {selectedFile
                      ? selectedFile.name
                      : "Click here to select a file from your computer"}
                  </span>
                  <input
                    id="file-upload"
                    className="absolute inset-0 w-full  opacity-0 cursor-pointer"
                    type="file"
                    accept='.pdf'
                    onChange={handleFileChange}
                  />
                </div>

              </label>




            </div>







<h1 className='text-center'>&#x2022; Note : Attach PDF File only</h1>

          </form>
        </div>
      </div>
    </div>
  )
}

export default CreateDocumentTemplate
